module.exports = __webpack_public_path__ + "img/iPhone8Plus-1.85b9a85c.png";